import { POLYGON_AMOY } from '../contracts/config';

/**
 * Get blockchain explorer URL for transaction
 */
export const getTransactionUrl = (txHash: string): string => {
  return `${POLYGON_AMOY.blockExplorerUrls[0]}/tx/${txHash}`;
};

/**
 * Get blockchain explorer URL for address
 */
export const getAddressUrl = (address: string): string => {
  return `${POLYGON_AMOY.blockExplorerUrls[0]}/address/${address}`;
};

/**
 * Get blockchain explorer URL for contract
 */
export const getContractUrl = (contractAddress: string): string => {
  return `${POLYGON_AMOY.blockExplorerUrls[0]}/address/${contractAddress}`;
};

